import { defineStore } from 'pinia';

import { WorkflowStatus } from '@/workflow-status';
import { getSearchPills, getSearchQueryString, getSearchQueryStringWithoutStatus } from '@/store/search-utils';

export const useMarinLitSearchStore = defineStore('marinLitSearch', {

  // STATE
  state: () => ({
    UserList: [],
    CompoundStatusList: [
      'New',
      'New to marine',
      'Revision',
      'New and revised in a subsequent article',
      'New to marine and revised in a subsequent article',
      'Revision and revised in a subsequent article'
    ],
    SearchParams: {
      // METADATA
      'status':                { 'value': WorkflowStatus.DRAFT },
      'createdBy':             { 'label': 'Created by', 'value': '' },
      'lastModifiedBy':        { 'label': 'Last modified by', 'value': '' },
      'datePublishedFrom':     { 'label': 'Published after', 'value': '' },
      'datePublishedTo':       { 'label': 'Published before', 'value': '' },
      'dateCreatedFrom':       { 'label': 'Created after', 'value': '' },
      'dateCreatedTo':         { 'label': 'Created before', 'value': '' },
      'dateLastModifiedFrom':  { 'label': 'Last modified after', 'value': '' },
      'dateLastModifiedTo':    { 'label': 'Last modified before', 'value': '' },

      // ARTICLE
      'articleFreeText':       { 'label': 'Article title / trivial name', 'value': '' },
      'marinLitId':            { 'label': 'MarinLit ID (Article)', 'value': '' },
      'doi':                   { 'label': 'DOI', 'value': '' },

      // COMPOUND
      'compoundName':          { 'label': 'Compound name', 'value': '' },
      'inchiKey'        :      { 'label': 'InChIKey', 'value': '' },
      'compoundMarinLitId':    { 'label': 'MarinLit ID (Compound)', 'value': '' },
      'compoundStatus':        { 'label': 'Compound status', 'value': '' },
    },
  }),

  // ACTIONS
  actions: {
    updateField({ path, value }) {
      const segments = path.split('.');
      let target = this;
      for (let i = 0; i < segments.length - 1; i++) {
        if (!(segments[i] in target)) {
          target[segments[i]] = {}; // create intermediate object if it does not exist
        }
        target = target[segments[i]];
      }
      target[segments[segments.length - 1]] = value;
    },
  },

  // GETTERS
  getters: {
    getSearchPills,
    getSearchQueryString,
    getSearchQueryStringWithoutStatus,
  },

});

